// extracted by mini-css-extract-plugin
module.exports = {"shareButton":"OIOXrC","children":"WJyLqT"};